module.exports = __webpack_public_path__ + "img/5.0352dce4.png";